import { useEffect, useState } from "react";
import { Alert, Button, Dropdown, Modal, Spinner, Table } from "react-bootstrap";
import { api } from "../../helpers/apiCore";
import { endpoints } from "../../helpers/Endpoints";
import searchIcon from "../../assets/icons/search.svg";
import toggleBtn from "../../assets/icons/toggle_btn.svg";
import eyeIcon from "../../assets/icons/eye.svg";
import deleteIcon from "../../assets/icons/delete.svg";
import FormInput from "../../components/FormInput";
import PaginationComponent from "../../components/PaginationComponent";
import TableColumnDropdownCheck from "../../components/TableColumnDropdownCheck";
import RoleDetails from "./RoleDetails";
import moment from "moment";
import { IRole, Permission } from "../../types";


const Roles_Permissions = () => {
	const [rolesAndPermissions, setRolesAndPermissions] = useState<IRole[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [expandedRows, setExpandedRows] = useState<string[]>([]);
	const [selectedRole, setSelectedRole] = useState<IRole | null>(null);
	const [roleIdToDelete, setRoleIdToDelete] = useState<string | null>(null);
	const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
	const [showModal, setShowModal] = useState(false);
	const [confirmDelete, setConfirmDelete] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');
	const [showAlert, setShowAlert] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [paginationData, setPaginationData] = useState({
		currentPage: 1,
		totalPages: 1,
		hasNextPage: false,
		hasPreviousPage: false,
		nextPage: null,
		previousPage: null
	});

	const allColumns = [
		'Role', 'Permissions', 'Date Created', 'Status'
	];

	const formatDate = (dateString: moment.MomentInput) => {
		return moment(dateString).format("DD-MM-YYYY");
	};


	const handleViewRole = (role: IRole) => {
		setSelectedRole(role);
		setShowModal(true);
	};

	const handleHideRole = () => {
		setShowModal(false);
		setSelectedRole(null);
	};

	const toggleExpandedRow = (roleId: string) => {
		setExpandedRows(current => {
			const isExpanded = current.includes(roleId);
			if (isExpanded) {
				return current.filter(id => id !== roleId);
			} else {
				return [...current, roleId];
			}
		});
	};

	const handlePaginate = (pageNumber: number) => {
		setPaginationData((prevData) => ({ ...prevData, currentPage: pageNumber }));
	};

	const requestDeleteRole = (roleId: string) => {
		setError(null);
		setRoleIdToDelete(roleId);
		setConfirmDelete(true);
	};

	const handleDeleteRole = async () => {
		if (!roleIdToDelete) {
			setError('No role selected for deletion');
			setShowAlert(true);
			return;
		}
			setIsLoading(true);
			try {
				api.setAuthorization(api.getLoggedInUser());
				const response = await api.delete(endpoints.deleteRole(roleIdToDelete));
				setSuccessMessage(response.data.message);
				setShowAlert(true);
				setConfirmDelete(false);
				setRoleIdToDelete(null);
				setTimeout(() => {
					setShowAlert(false);
					setSuccessMessage('');
					fetchAllRolesAndPermissions();
				}, 4000);
			} catch (error: any) {
				const message = error?.response?.data?.message || 'Cannot delete role, please try again';
				setError(message);
				setShowAlert(true);
			} finally {
				setIsLoading(false);
			}
		};

	// const fetchAllRolesAndPermissions = async () => {
	// 	setIsLoading(true);
	// 	try {
	// 		api.setAuthorization(api.getLoggedInUser());
	// 		const response = await api.get(endpoints.getAllRolesAndPermissions, {});

	// 		setRolesAndPermissions(response.data);

	// 		console.log(response.data, 'response----')

	// 		console.log(rolesAndPermissions, 'roles-and-permissions')
	// 		setPaginationData({
	// 			currentPage: response.data.data.page,
	// 			totalPages: response.data.data.totalPages,
	// 			hasNextPage: response.data.data.hasNextPage,
	// 			hasPreviousPage: response.data.data.hasPreviousPage,
	// 			nextPage: response.data.data.nextPage,
	// 			previousPage: response.data.data.previousPage
	// 		});
	// 		setIsLoading(false);
	// 	} catch (error) {
	// 		console.error("Error fetching admins:", error);
	// 	} finally {
	// 		setIsLoading(false);
	// 	}
	// };

	const fetchAllRolesAndPermissions = async () => {
		setIsLoading(true);
		try {
			api.setAuthorization(api.getLoggedInUser());
			const response = await api.get(endpoints.getAllRolesAndPermissions, {});

			console.log(response.data, 'response----');

			if (response.data?.data && Array.isArray(response.data.data)) {
				setRolesAndPermissions(response.data.data);
				setPaginationData({
					currentPage: response.data.page || 1,
					totalPages: response.data.totalPages || 1,
					hasNextPage: response.data.hasNextPage || false,
					hasPreviousPage: response.data.hasPreviousPage || false,
					nextPage: response.data.nextPage || null,
					previousPage: response.data.previousPage || null
				});
			} else if (Array.isArray(response.data)) {
				setRolesAndPermissions(response.data);
				setPaginationData({
					currentPage: 1,
					totalPages: 1,
					hasNextPage: false,
					hasPreviousPage: false,
					nextPage: null,
					previousPage: null
				});
			} else {
				console.error('Unexpected response structure:', response.data);
				setRolesAndPermissions([]);
			}

			console.log(response.data, 'roles-and-permissions');
		} catch (error) {
			console.error("Error fetching roles and permissions:", error);
			setError('Failed to fetch roles and permissions');
			setRolesAndPermissions([]);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchAllRolesAndPermissions();
	}, [paginationData.currentPage]);



	// const renderPermissions = (permissions: Permission[], roleId: string) => {
	// 	const isExpanded = expandedRows.includes(roleId);
	// 	let permissionsToDisplay = permissions;

	// 	if (!isExpanded) {
	// 		permissionsToDisplay = permissions.slice(0, 3);
	// 	};

	// 	return (
	// 		<>
	// 			{permissionsToDisplay.map((permission, index) => (
	// 				<div key={index} style={{display:'flex', gap:'5px'}}>
	// 					{Object.entries(permission).map(([category]) => (
	// 							<p key={category} className="permissions-list">{category}</p>
	// 					))}
	// 				</div>
	// 			))}
	// 			{permissions.length > 3 && (
	// 				<Button onClick={() => toggleExpandedRow(roleId)}
	// 					className="roles-row-toggle mt-2">
	// 					{isExpanded ? "- less" : "+ more"}
	// 				</Button>
	// 			)}
	// 		</>
	// 	);
	// };

	const renderPermissions = (permissions: Permission[], roleId: string) => {
	const isExpanded = expandedRows.includes(roleId);
	let permissionsToDisplay = permissions;

	if (!isExpanded) {
		permissionsToDisplay = permissions.slice(0, 3);
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
				{permissionsToDisplay.map((permission, index) => (
					<div key={index} style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
						{Object.entries(permission).map(([category, actions]) => (
							<div 
								key={category} 
								className="permissions-list"
								style={{
									display: 'flex',
									alignItems: 'center',
									padding: '4px 8px',
									backgroundColor: '#f8f9fa',
									borderRadius: '4px',
									border: '1px solid #dee2e6',
									fontSize: '0.875rem'
								}}
							>
								<span style={{ fontWeight: '500' }}>{category}</span>
								<span style={{ 
									marginLeft: '4px', 
									color: '#6c757d',
									fontSize: '0.75rem' 
								}}>
									({Array.isArray(actions) ? actions.length : 0})
								</span>
							</div>
						))}
					</div>
				))}
			</div>
			{permissions.length > 3 && (
				<Button 
					onClick={() => toggleExpandedRow(roleId)}
					className="roles-row-toggle"
					style={{ 
						alignSelf: 'flex-start',
						padding: '2px 8px',
						fontSize: '0.75rem'
					}}
				>
					{isExpanded ? "- Show less" : `+ Show more (${permissions.length - 3})`}
				</Button>
			)}
		</div>
	);
};


	return (
		<>
			<div className="table-topbar">
				<div className="search_bar">
					<img src={searchIcon} alt="search" />
					<FormInput name="search" placeholder="Search" />
				</div>

				<div className="action-flex">
					<div className="column-select background-red">
						<TableColumnDropdownCheck
							options={allColumns}
							selectedOptions={selectedColumns}
							onSelectionChange={setSelectedColumns}
						/>
					</div>
				</div>
			</div>

			<div className="table-body">
				<Table>
					{isLoading ? (
						<div className="spinner-div">
							<Spinner animation="border" size="sm" role="status" />
						</div>
					) : rolesAndPermissions?.length > 0 ? (
						<>
							<thead>
								<tr>
									<th className="custom-thead-bg">
										<FormInput name="requery" type="checkbox" />
									</th>

									{selectedColumns.includes('Role') && <th className="custom-thead-bg">Role</th>}
									{selectedColumns.includes('Permissions') && <th className="custom-thead-bg">Permissions</th>}
									{selectedColumns.includes('Date Created') && <th className="custom-thead-bg">Date Created</th>}
									{selectedColumns.includes('Status') && <th className="custom-thead-bg">Status</th>}
									<th className="custom-thead-bg"></th>
								</tr>
							</thead>

							<tbody>
								{rolesAndPermissions.map(role => (
									<tr key={role.id}>
										<td className="custom-tbody">
											<div>
												<FormInput name="requery" type="checkbox" />
											</div>
										</td>
										{selectedColumns.includes('Role') && <td>{role.name}</td>}
										{selectedColumns.includes('Permissions') && <td>
											{renderPermissions(role.permissions, role.id)}
										</td>}
										{selectedColumns.includes('Date Created') && <td>{formatDate(role.created_at)}</td>}
										{/* {selectedColumns.includes('No. of Admins') && <td>{role.userCount}</td>} */}
										{/* {selectedColumns.includes('Status') && <td>
											<div className={role.isActive ? 'book-status-enabled' : 'book-status-disabled'}>
												{role.role ? 'ACTIVE' : 'INACTIVE'}
											</div>
										</td>} */}
										<td>
											<div className="custom-popover">
												<Dropdown>
													<Dropdown.Toggle variant="link" id="dropdown-basic" className="roles-options">
														<img src={toggleBtn} alt="toggle open details" style={{ cursor: 'pointer' }} />
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item onClick={() => handleViewRole(role)}>
															<img src={eyeIcon} alt="preview" style={{ marginRight: '6px' }} />
															View Details
														</Dropdown.Item>
														<Dropdown.Item onClick={() => requestDeleteRole(role.id)}>
															<img src={deleteIcon} alt="delete" style={{ marginRight: '6px' }} />
															Delete Role
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
								<>
									{confirmDelete && (
										<Modal
											show={confirmDelete}
											onHide={() => {
												setConfirmDelete(false);
												setRoleIdToDelete(null);
											}}
										>
											<Modal.Body>
												<>
													<p className="text-danger">Are you sure you want to delete this role along with its permissions? This action cannot be undone.</p>
													<div className="flex-btns mb-3">
														<Button
															variant="secondary"
															onClick={() => {
																setConfirmDelete(false);
																setRoleIdToDelete(null);
															}}
															disabled={isLoading}
														>
															Cancel
														</Button>
														<Button variant="danger" onClick={handleDeleteRole} disabled={isLoading}>
															{isLoading ? <Spinner animation="border" size="sm" /> : "Proceed"}
														</Button>
													</div>
												</>
											</Modal.Body>
										</Modal>
									)}

									{showAlert && successMessage && (
										<Modal show={showAlert} onHide={() => setShowAlert(false)}>
												<Alert variant="success" style={{padding:'20px'}}>
													{successMessage}
												</Alert>
										</Modal>
									)}

									{showAlert && error && (
										<Modal show={showAlert} onHide={() => setShowAlert(false)}>
												<Alert variant="danger" style={{padding:'20px'}}>
													{error}
												</Alert>
										</Modal>
									)}
								</>
							</tbody>
						</>
					) : (
						<div className="no-results">
							No roles found.
						</div>
					)}
				</Table>
			</div>

			<PaginationComponent
				currentPage={paginationData.currentPage}
				totalPages={paginationData.totalPages}
				hasNextPage={paginationData.hasNextPage}
				hasPreviousPage={paginationData.hasPreviousPage}
				nextPage={paginationData.nextPage}
				previousPage={paginationData.previousPage}
				onPaginate={handlePaginate}
			/>

			{selectedRole && (
				<RoleDetails
					showModal={showModal}
					onHide={handleHideRole}
					// roleId={selectedRoleId}
					roleData={selectedRole}
					formatDate={formatDate}
				/>
			)}
		</>
	)
}

export default Roles_Permissions;